// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2pMpz","title":"InfoRow_title__3SCET"};